import React from 'react';
import { Container } from 'react-bootstrap';
import { Route, Switch, withRouter } from 'react-router';
import NotFound from '../NotFound';
import CachedResponse from '../common/CachedResponse';
import BrowseRequests from './BrowseRequests';
import MyClaims from './MyClaims';
import NewRequests from './NewRequests';
import {
  ROLE_INSTALLER,
  ROLE_INVENTORY_MANAGER,
  ROLE_SERVICE,
  ROLE_TECH
} from '../../helpers/constants';
import { userHasAnyRole } from '../../helpers/roleHelpers';

const Requests = () => {
  const getActivePage = () => {
    return (
      <Switch>
        <Route exact path="/service-requests/browse">
          <CachedResponse
            listEndpoint={'app-choices'}
            render={appChoices => <BrowseRequests appChoices={appChoices} />}
          />
        </Route>
        {userHasAnyRole(ROLE_SERVICE) && (
          <>
            <Route exact path="/service-requests/new">
              <NewRequests />
            </Route>
            <Route exact path="/service-requests/my-claims">
              <MyClaims />
            </Route>
          </>
        )}

        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    );
  };

  if (userHasAnyRole(ROLE_TECH, ROLE_INSTALLER, ROLE_INVENTORY_MANAGER)) {
    return <NotFound text="You are not authorized to view this page" />;
  }

  return (
    <>
      <Container fluid className="h-100 pt-2 pb-3 px-md-2">
        {getActivePage()}
      </Container>
    </>
  );
};

export default withRouter(Requests);
